module.exports = __webpack_public_path__ + "img/Group 1047three.40c50ac4.png";